module.exports = __webpack_public_path__ + "img/water.31620a09.png";